// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"264140c2","977":"16159dbf"}[chunkId] + ".chunk.js";
};